import React from "react"
import "./style.css"
const Loader = () => {
  return <div className="loader-o"></div>
}

export default Loader
